var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition-group',{staticClass:"piece-list",attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.pieces),function(piece){return _c('piece',{key:piece.id,staticClass:"piece-list__item",attrs:{"piece":piece,"nonEdit":_vm.nonEdit},on:{"delete":_vm.onDelete,"edit":_vm.onEdit}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }